.overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(15, 23, 42, 0.5);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    z-index: var(--tempest-z-modal);
    animation: tempest-drawer-overlay var(--tempest-duration-base) var(--tempest-ease-out);
}

.panel {
    position: fixed;
    top: 0;
    bottom: 0;
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    box-shadow: var(--tempest-shadow-xl);
    display: flex;
    flex-direction: column;
    z-index: calc(var(--tempest-z-modal) + 1);
    animation-duration: var(--tempest-duration-slow);
    animation-timing-function: var(--tempest-ease-emphasized);
    animation-fill-mode: both;
}

.right {
    right: 0;
    width: min(420px, 92vw);
    padding-right: var(--tempest-safe-area-right);
    animation-name: tempest-drawer-in-right;
}

.left {
    left: 0;
    width: min(420px, 92vw);
    padding-left: var(--tempest-safe-area-left);
    animation-name: tempest-drawer-in-left;
}

.top {
    top: 0;
    left: 0;
    right: 0;
    bottom: auto;
    height: min(70vh, 480px);
    height: min(70dvh, 480px);
    padding-top: var(--tempest-safe-area-top);
    border-radius: 0 0 var(--tempest-radius-xl) var(--tempest-radius-xl);
    animation-name: tempest-drawer-in-top;
}

.bottom {
    bottom: 0;
    left: 0;
    right: 0;
    top: auto;
    height: min(70vh, 480px);
    height: min(70dvh, 480px);
    padding-bottom: var(--tempest-safe-area-bottom);
    border-radius: var(--tempest-radius-xl) var(--tempest-radius-xl) 0 0;
    animation-name: tempest-drawer-in-bottom;
}

/* Bottom-sheet drag handle (4px pill at top center). */
.handle {
    position: relative;
    width: 36px;
    height: 4px;
    margin: var(--tempest-space-2) auto;
    background-color: var(--tempest-border-strong);
    border-radius: var(--tempest-radius-full);
    flex-shrink: 0;
}

.handleTop {
    margin-top: auto;
    margin-bottom: var(--tempest-space-2);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-4) var(--tempest-space-5);
    border-bottom: 1px solid var(--tempest-border);
}

.title {
    margin: 0;
    font-size: var(--tempest-text-lg);
    font-weight: var(--tempest-weight-semibold);
    line-height: var(--tempest-leading-snug);
}

.close {
    background: none;
    border: none;
    color: var(--tempest-text-muted);
    padding: var(--tempest-space-1);
    border-radius: var(--tempest-radius-sm);
    display: flex;
    align-items: center;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .close:hover {
        background-color: var(--tempest-surface);
        color: var(--tempest-text);
    }
}

.close:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: var(--tempest-focus-ring-offset);
}

.body {
    padding: var(--tempest-space-5);
    overflow-y: auto;
    flex: 1;
    line-height: var(--tempest-leading-normal);
}

.footer {
    display: flex;
    justify-content: flex-end;
    gap: var(--tempest-space-2);
    padding: var(--tempest-space-4) var(--tempest-space-5);
    border-top: 1px solid var(--tempest-border);
    background-color: var(--tempest-surface);
}

@keyframes tempest-drawer-overlay {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes tempest-drawer-in-right {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes tempest-drawer-in-left {
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0);
    }
}

@keyframes tempest-drawer-in-top {
    from {
        transform: translateY(-100%);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes tempest-drawer-in-bottom {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

@media (prefers-reduced-motion: reduce) {
    .panel,
    .overlay {
        animation: none;
    }
}
